import React from 'react'

export default function TopPerformerCard({ title, firstValue, secondValue, icon }) {
  return (
    <div className="mb-3">
      <div className="shadow-sm border-0 rounded-3 p-1 mb-2">
        <div className="card-body p-0">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="text-muted mb-2 small fw-normal">{title}</p>
          </div>
          <h6 className="mb-0 fs-4 fw-bold">{firstValue}</h6>
          <h6 className="mb-0 fs-4 fw-bold">{secondValue}</h6>
        </div>
      </div>
    </div>
  )
}